import { Injectable } from '@angular/core';
import { LanguageService } from '@shared/services/language.service';

import * as moment from 'moment';

/** ? */
@Injectable({
  providedIn: 'root'
})
export class DateService {
  constructor(private readonly languageService: LanguageService) {}

  public formatDateLocal(date: Date, format?: string): string {
    let dateFormat = format ? format : 'LL';
    let language = this.languageService.language;
    let localeLang = language === 'no' ? 'nb' : language;

    return moment(date).locale(localeLang).format(dateFormat);
  }
}
